module.exports = __webpack_public_path__ + "media/src/images/logo_highres-b496140d36848ca5a3bdd469ed4e4d80.png";